import React from 'react';
import CardImage from '../CardImage';

function CardCarousel({ cards, onAddCard, onDeleteCard }) {
  if (cards.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-10 text-center">
        <span className="text-5xl mb-3">💳</span>
        <h3 className="text-lg font-semibold text-on-surface mb-1">No cards yet</h3>
        <p className="text-sm text-on-surface-variant mb-4">Add your first card to start finding the best benefits</p>
        <button
          onClick={onAddCard}
          className="px-6 py-2.5 bg-primary text-on-primary rounded-full text-sm font-semibold hover:bg-primary-dark transition-colors active:scale-[0.97]"
        >
          + Add Card
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex gap-4 overflow-x-auto no-scrollbar pb-2 -mx-1 px-1">
        {cards.map((card) => {
          const displayName = card.cardName || `${card.bank} ${card.network}`;
          return (
            <div key={card.id} className="flex-shrink-0 group relative">
              <div className="relative">
                <CardImage card={card} size="large" />
                <button
                  onClick={() => {
                    if (window.confirm('Remove this card?')) {
                      onDeleteCard(card.id);
                    }
                  }}
                  className="absolute -top-2 -right-2 w-5 h-5 bg-error/90 text-white rounded-full text-xs font-bold flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-md"
                  aria-label="Delete card"
                >
                  ×
                </button>
              </div>
              <p className="text-xs font-medium text-on-surface-variant mt-2 text-center max-w-[180px] truncate">
                {displayName}
              </p>
            </div>
          );
        })}
        {/* Add card button */}
        <button
          onClick={onAddCard}
          className="flex-shrink-0 w-[180px] h-[114px] rounded-2xl border-2 border-dashed border-outline-variant/50 flex flex-col items-center justify-center gap-1 text-on-surface-variant hover:border-primary hover:text-primary transition-colors"
        >
          <span className="material-symbols-outlined text-3xl">add_card</span>
          <span className="text-xs font-medium">Add Card</span>
        </button>
      </div>
    </div>
  );
}

export default CardCarousel;
